import { render, staticRenderFns } from "./smallProgram.vue?vue&type=template&id=3dac2486&scoped=true"
import script from "./smallProgram.vue?vue&type=script&lang=ts"
export * from "./smallProgram.vue?vue&type=script&lang=ts"
import style0 from "./smallProgram.vue?vue&type=style&index=0&id=3dac2486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dac2486",
  null
  
)

export default component.exports